<template>
	<div>
		<div class="top">
			<div class="welcome">
				<p>欢迎来到教育专家网！</p>
				<div v-if="!shows" class="head-top welcome" @click="personal(1)">
					<img :src="user.avatar" alt=""
						style="width: 28px;height: 28px;display: block;margin: 0;border-radius: 50%;">
					<span style="font-size: 14px;color: #222222;margin-left: 8px;">{{user.nickname}}</span>
				</div>
				<p class="login cursor" @click="setLoginShow()" v-if="shows">登录/注册</p>
			</div>
			<div class="welcome">
				<div class="type-1 cursor" @click="homeView">
					<img src="../assets/head/Frame.png" alt="">
					<p>网站首页</p>
				</div>
				<div class="type-1 cursor" @click="myCollect">
					<img src="../assets/head/Frame (1).png" alt="">
					<p>我的收藏</p>
				</div>
				<div class="type-1 cursor" @click="myKf">
					<img src="../assets/head/Frame (2).png" alt="">
					<p>我的客服</p>
				</div>
				<!-- 我的客服弹窗 -->
				<el-dialog title="" :visible.sync="dialogVisibleTitle" width="40%" :before-close="handleClose">
					<div class="is-flex jus-bet">
						<div></div>
						<div class="font5">
							<p class="font5-1">客服微信</p>
							<img :src="this.wxQrCode" alt="" class="wid-30">
						</div>
						<div class="font5">
							<p class="font5-2">联系电话</p>
							<div class="is-flex" style="align-items: center;">
								<img src="../assets/head/lian.png" alt="">
								<p
									style="font-family: font10;color: #3377FF;font-size: 1.25rem;padding-left: 0.5rem;white-space: nowrap;">
									{{this.mobile}}
								</p>
							</div>
						</div>
						<div></div>
					</div>
				</el-dialog>
				<!-- 登录微信授权弹窗 -->
				<!--       <el-dialog title="" :visible.sync="dialogLogin" width="30%" :before-close="handleClose">
                    <div class="is-flex jus-bet">
                        <div></div>
                        <div class="font5">
                            <p class="font5-1">微信扫码一键登录</p>
                            <p class="zhuc">未注册的微信号将自动创建本平台账号</p>
                            <div class="tan-dele" id="login_container"></div>
                            <div class="gouxuan is-flex">
                                <el-checkbox v-model="checked"></el-checkbox>
                                <p>登录代表您已同意<span @click="yhxy">《用户协议》</span> 、<span @click="yszc">《隐私政策》</span></p>
                            </div>
                        </div>
                        <div></div>
                    </div>
                </el-dialog> -->
				<!-- tanchuang -->
				<!-- 登录微信授权弹窗 -->
				<div v-show="dialogLogin" class="tan-dialog">
					<div class="tanchuang" style="">
						<div class="is-flex jus-bet">
							<div></div>
							<img src="../../src/assets/expert/close.png" alt="" @click="closeDialog"
								style="width: 20px;height: 20px;padding: 20px 20px 0 0;">
						</div>
						<div class="is-flex jus-bet">
							<div></div>
							<div class="font5">
								<p class="font5-1">微信扫码一键登录</p>
								<p class="zhuc">未注册的微信号将自动创建本平台账号</p>
								<div class="tan-dele" id="login_container"></div>
								<img src="../../src/assets/phone-login.png" alt="" class="phone-logins"
									@click="accountLogin" />
								<div class="gouxuan is-flex">
									<el-checkbox v-model="checked"></el-checkbox>
									<p>登录代表您已同意<span @click="yhxy">《用户协议》</span> 、<span @click="yszc">《隐私政策》</span></p>
								</div>
							</div>
							<div></div>
						</div>
						<div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="phoneShow" width="600px" :show-close="false" :close-on-click-modal="false">
			<div>
				<div class="pop-title">绑定手机号</div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item prop="mobile">
						<div class="inp-text">
							<img src="../../src/assets/phone.png" alt="" class="inp-text-icon" />
							<el-input class="no-border" placeholder="请输入手机号" v-model="ruleForm.mobile"></el-input>
						</div>
					</el-form-item>
					<el-form-item prop="code">
						<div class="inp-text">
							<img src="../../src/assets/cipher.png" alt="" class="inp-text-icon" />
							<el-input class="no-border" placeholder="请输入验证码" v-model="ruleForm.code"></el-input>
							<div class="code-btn" v-if="stus" @click="setCode">点击获取</div>
							<div class="code-btn" v-if="!stus">{{sunmax}}s后获取</div>
						</div>
					</el-form-item>
					<el-form-item>
						<el-button class="pop-btn" type="primary" @click="setLogin">立即绑定</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="accountShow" width="600px" :show-close="false" :close-on-click-modal="false" center>
			<div>
				<img src="../../src/assets/expert/close.png" alt="" @click="accountShow = false" class="close-icon">
				<!-- <div class="tabs">
					<div :class="tabIndex == 0?'tabs-items':'tabs-item'" @click="tabIndex = 0">手机验证码</div>
					<div :class="tabIndex == 1?'tabs-items':'tabs-item'" @click="tabIndex = 1">账号密码</div>
				</div> -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
					<div v-if="tabIndex == 0">
						<el-form-item prop="mobile">
							<div class="inp-text">
								<img src="../../src/assets/phone.png" alt="" class="inp-text-icon" />
								<el-input class="no-border" placeholder="请输入手机号" v-model="ruleForm.mobile"></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="code">
							<div class="inp-text">
								<img src="../../src/assets/cipher.png" alt="" class="inp-text-icon" />
								<el-input class="no-border" placeholder="请输入验证码" v-model="ruleForm.code"></el-input>
								<div class="code-btn" v-if="stus" @click="setCode">点击获取</div>
								<div class="code-btn" v-if="!stus">{{sunmax}}s后获取</div>
							</div>
						</el-form-item>
						<el-form-item>
							<img src="../../src/assets/wechat-login.png" alt="" class="phone-login"
								@click="phoneLogin" />
							<el-button class="pop-btn" type="primary" @click="setCodeLogin">登录</el-button>
						</el-form-item>
					</div>
					<div v-if="tabIndex == 1">
						<el-form-item prop="mobile">
							<div class="inp-text">
								<img src="../../src/assets/phone.png" alt="" class="inp-text-icon" />
								<el-input class="no-border" placeholder="请输入手机号" v-model="ruleForm.mobile"></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="password">
							<div class="inp-text">
								<img src="../../src/assets/cipher.png" alt="" class="inp-text-icon" />
								<el-input class="no-border" placeholder="请输入登录密码"
									v-model="ruleForm.password"></el-input>
							</div>
						</el-form-item>
						<el-form-item>
							<img src="../../src/assets/wechat-login.png" alt="" class="phone-login"
								@click="phoneLogin" />
							<el-button class="pop-btn" type="primary" @click="setCipherLogin">登录</el-button>
						</el-form-item>
					</div>
					<div class="gouxuan is-flex">
						<el-checkbox v-model="checked"></el-checkbox>
						<p>登录代表您已同意<span @click="yhxy">《用户协议》</span> 、<span @click="yszc">《隐私政策》</span></p>
					</div>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	// import wxlogin from 'vue-wxlogin';
	// import QRCode from 'qrcodejs2'
	import {
	getInfo,
	getUser,
	getWxLogin,
	sendSmsCode,
	smsLogin,
	cipherLogin
} from '@/api/api.js';
import { 
  setForceChangePassword, 
  setForceChangePasswordReason,
  setPasswordWillExpire,
  clearPasswordStatus
} from '@/utils/passwordStatus';
	export default {
		components: {
			// QRCode
		},
		// props: ['loginShow'],
		data() {
			return {
				shows: false,
				dialogVisibleTitle: false,
				checked: true,
				dialogLogin: false,
				wxQrCode: '',
				mobile: '',
				user: '',
				phoneShow: false,
				accountShow: false,
				tabIndex: 0,
				stus: true,
				sunmax: 60,
				Wechat_return_code: '',
				wx_parseUrl: '',
				ruleForm: {
					name: '',
					code: '',
				},
				rules: {
					mobile: [{
						required: true,
						message: '请填写手机号码',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请填写验证码',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请填写密码',
						trigger: 'blur'
					}]
				}
			}
		},
		watch: {
			$route: {
				handler: function(route) {
					console.log(route.query.code, '------')
					// if (route.query.code) {
					//   this.getToken(route.query);
					// }
					// if (route.query.loginType) {
					//   this.loginType = route.query.loginType;
					//   this.bindPhone = route.query.bindPhone;
					// }
					// this.redirect = route.query && route.query.redirect;
				},
				immediate: true,
			},
			loginShow(val) {
				this.dialogLogin = val;
			},
			'$root.loginShow'(val) {
				if (val) {
					this.dialogLogin = true;
				}
			}
		},
		created() {
			this.Get_wechat_callback_information();
		},
		mounted() {
			this.getEcor();
			this.getInfos();
			this.getUsersa();
		},
		methods: {
			accountLogin() {
				this.$root.loginShow = false;
				this.dialogLogin = false;
				this.accountShow = true;
			},
			phoneLogin() {
				this.accountShow = false;
				this.$root.loginShow = true;
				this.dialogLogin = true;
			},
			setLogin() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						smsLogin({
							mobile: this.ruleForm.mobile,
							code: this.ruleForm.code,
							socialCode: this.wx_parseUrl.code,
							socialState: this.wx_parseUrl.state,
							socialType: 32,
						}).then(res => {
							if (res.code == 0) {
								localStorage.setItem('refreshShow', false)
								this.token = res.data.accessToken;
								localStorage.setItem('keyToken', this.token)
								// 检查密码状态
								this.checkPasswordStatus(res.data);
								this.phoneShow = false;
								window.location.href = 'https://www.zgjyzjw.com';
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			setCodeLogin() {
				this.rules.password = [];
				this.rules.code = [{
					required: true,
					message: '请填写验证码',
					trigger: 'blur'
				}];
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						smsLogin({
							mobile: this.ruleForm.mobile,
							code: this.ruleForm.code,
						}).then(res => {
							if (res.code == 0) {
								localStorage.setItem('refreshShow', false)
								this.token = res.data.accessToken;
								localStorage.setItem('keyToken', this.token)
								// 检查密码状态
								this.checkPasswordStatus(res.data);
								this.accountShow = false;
								window.location.href = 'https://www.zgjyzjw.com';
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			setCipherLogin() {
				this.rules.code = [];
				this.rules.password = [{
					required: true,
					message: '请填写密码',
					trigger: 'blur'
				}];
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						cipherLogin({
							mobile: this.ruleForm.mobile,
							password: this.ruleForm.password,
						}).then(res => {
							if (res.code == 0) {
								localStorage.setItem('refreshShow', false)
								this.token = res.data.accessToken;
								localStorage.setItem('keyToken', this.token)
								// 检查密码状态
								this.checkPasswordStatus(res.data);
								this.accountShow = false;
								window.location.href = 'https://www.zgjyzjw.com';
							} else {
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			setCode() {
				sendSmsCode({
					mobile: this.ruleForm.mobile,
					scene: 1,
				}).then(res => {
					if (res.code == 0) {
						this.stus = false;
						let timeInt = setInterval(() => {
							this.sunmax--;
							if (this.sunmax <= 0) {
								this.stus = true;
								this.sunmax = 60;
								clearInterval(timeInt);
							}
						}, 1000);
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			getUsersa() {
				getUser().then(res => {
						this.user = res.data;
						console.log(this.user)
						if (this.user == null) {
							this.shows = true;
						} else {
							this.shows = false;
							this.$store.commit('gertUsers', this.user)
						}
					})
					.catch(error => {});
			},
			getInfos() {
				getInfo().then(res => {
						this.wxQrCode = res.data.wxQrCode;
						this.mobile = res.data.mobile;

					})
					.catch(error => {});
			},
			getEcor() {
				this.$nextTick(() => {
					this.get_wx_qrcode();
				});
			},
			get_wx_qrcode() {
				document.getElementById('login_container').innerHTML = ''
				//从微信的开发文档不难看出回调域名需要经过encodeURIComponent处理
				var obj = new WxLogin({
					self_redirect: false,
					id: "login_container", //需要承载二维码的容器id  
					appid: "wxe6ff3265a8b51854",
					scope: "snsapi_login", //网页授权，目前网页只有这一种方式，静默授权
					redirect_uri: encodeURIComponent('https://www.zgjyzjw.com'), //回调域名
					state: '1',
					style: "black",
					href: "data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsgZGlzcGxheTogbm9uZTt9LmltcG93ZXJCb3ggLnN0YXR1cy5zdGF0dXNfYnJvd3NlciB7IGRpc3BsYXk6IG5vbmU7fS5pbXBvd2VyQm94IC5xcmNvZGUgeyBib3JkZXI6IG5vbmU7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiAxMjBweDttYXJnaW4tdG9wOiAwO2JvcmRlcjogMXB4IHNvbGlkICNlZWVlZWU7Ym9yZGVyLXJhZGl1czogMTBweDt9LmltcG93ZXJCb3ggLnN0YXR1c3sgZGlzcGxheTogbm9uZX0="
				});
			},
			// 'http://zgjyzjw.com?code=031XC9000gB3pR1oKZ100gE51z2XC90u&state=1'

			Get_wechat_callback_information() {
				this.Wechat_return_code = window.location.href;
				// let Wechat_return_code = 'http://zgjyzjw.com?code=031XC9000gB3pR1oKZ100gE51z2XC90u&state=1';
				//获取微信回调的code
				this.wx_parseUrl = this.$qs.parse(this.Wechat_return_code.split("?")[1]);
				if (this.wx_parseUrl.code) {
					localStorage.setItem('refreshShow', true)
					this.getLgon(this.wx_parseUrl.code, this.wx_parseUrl.state);
				} else {
					localStorage.setItem('refreshShow', false)
				}
				// let urlparamString = 'name=123&age=12';
				// let urlparamObj = this.$qs.parse(urlparamString)
				// console.log(urlparamObj); // 输出 {name: '123', age: '12'}
				// console.log(this.$qs.stringify(urlparamObj)); // 输出 name=123&age=12
			},
			getLgon(code, state) {
				getWxLogin({
						code: code,
						state: state,
						type: 32,
					}).then(res => {
						if (res.code == 0) {
							localStorage.setItem('refreshShow', false)
							this.token = res.data.accessToken;
							localStorage.setItem('keyToken', this.token)
							// 检查密码状态
							this.checkPasswordStatus(res.data);
							window.location.href = 'https://www.zgjyzjw.com';
						} else if (res.code == 1004003005 || res.code == 1004001005) {
							this.phoneShow = true;
						}
					})
					.catch(error => {});
			},
			setLoginShow() {
				// this.dialogLogin = true;
				this.$root.loginShow = true;
				this.dialogLogin = true;
				// this.shows = !this.shows;

			},
			closeDialog() {
				this.dialogLogin = false;
				this.$root.loginShow = false;
				this.$emit('getLoginShow', false);
			},
			personal(e) {
				this.$router.push('/personal/index')
				// if (this.$route.path !== '/personal/index') {
				//     this.$router.push('/personal/index')
				// } else {}

			},
			homeView() {
				this.$router.push('/allcontent')
			},
			myCollect() {
				let token = localStorage.getItem('keyToken');
				if (!token) {
					// this.$message({
					// 	message: '账号暂未登录',
					// 	type: 'warning'
					// });
					this.$root.loginShow = true;
					return false;
				}
				this.$router.push({
					path: '/collect/index',
					query: {
						footersType: 1,
					}
				})
			},
			myKf() {
				this.dialogVisibleTitle = true
			},
			handleClose() {
				this.dialogVisibleTitle = false;
				this.dialogLogin = false;
				this.$emit('getLoginShow', false);
			},
			yhxy() {
				this.dialogLogin = false;
				this.$root.loginShow = false;
				this.accountShow = false;
				this.phoneShow = false;
				this.$emit('getLoginShow', false);
				this.$router.push('/personal/service/userAgreement')
			},
			yszc() {
				this.dialogLogin = false;
				this.$root.loginShow = false;
				this.accountShow = false;
				this.phoneShow = false;
				this.$emit('getLoginShow', false);
				this.$router.push('/personal/service/privacyAgreement')
			},
			// 检查密码状态
			checkPasswordStatus(data) {
				// 清除之前的密码状态
				clearPasswordStatus();
				// 检查是否需要强制修改密码
				if (data.forceChangePassword) {
					setForceChangePassword(true);
					// 保存密码修改原因
					if (data.forceChangePasswordReason !== undefined) {
						setForceChangePasswordReason(data.forceChangePasswordReason);
					}
				}
				// 检查密码是否即将过期
				if (data.passwordWillExpire) {
					setPasswordWillExpire(true);
				}
			}
		}
	}
</script>

<style scoped>
	/deep/ #login_container iframe{
		height: 140px !important;
	}
	
	.top {
		font-size: 14px;
		color: #666666;
		height: 36px;
		background-color: #F5F5F5;
		display: flex;
		justify-content: space-between;
		padding: 0 19%;
	}

	.welcome {
		display: flex;
		align-items: center;
		font-family: font3;
	}

	.type-1 {
		display: flex;
		align-items: center;
	}

	.type-1 img {
		width: 16px;
		height: 16px;
	}

	.welcome .type-1:nth-child(2) {
		padding: 0 24px;
	}

	.type-1 p {
		padding-left: 2px;
	}

	.welcome .login {
		color: #3377FF;
		font-weight: normal;
		padding-left: 24px;
	}

	.head-top {
		margin-left: 24px;
	}

	/deep/.el-dialog__headerbtn {
		background: url("../assets/expert/close.png");
		background-size: cover;
		height: 20px;
		width: 20px;

		i {
			display: none;
			/* // 在这里隐藏弹窗默认的关闭图标 */
		}
	}

	/deep/.el-dialog {
		border-radius: 8px 8px 8px 8px;
	}

	.is-flex {
		display: flex;
		align-items: flex-start;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.font5 {
		font-family: font5;
		font-size: 16px;
		color: #222222;
		text-align: center;
	}

	.font5-1 {
		margin-bottom: 1rem;
	}

	.font5-2 {
		margin-bottom: 2.8125rem;
	}

	.zhuc {
		color: #666666;
		font-size: 14px;
		font-family: font3;
		margin-top: 1rem;
		margin-bottom: 2rem;
	}

	.gouxuan {
		margin-top: 2rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.gouxuan p {
		font-size: 14px;
		font-family: font3;
		padding-left: 0.5rem;
	}

	.gouxuan span {
		color: #3377FF;
		cursor: pointer;
	}

	.tan-dialog {
		position: fixed;
		/* width: 520px;
        height: 360px; */
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		z-index: 9854647;
		background: rgba(0, 0, 0, 0.5);
		/* background: rgba($color: #000000, $alpha: 0.5); */
		display: flex;
		justify-content: center;
		/* align-items: center; */


	}

	.tan-dele {
		/* border: 1px solid #eeeeee;
        border-radius: 0.5rem; */
		display: flex;
		justify-content: center;
		/* align-items: center; */
		width: 120px;
		height: 120px;
		margin: 0 auto;
		/* background: white; */
	}

	.wx_dialog_button_delete {
		position: absolute;
		right: 0px;
		top: 0px;
		height: 100px;
		width: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.tanchuang {
		width: 520px;
		height: 380px;
		background: white;
		border-radius: 8px 8px 8px 8px;
		margin-top: 120px;
	}

	/deep/.el-checkbox__inner::after {
		border: 2px solid #FFFFFF;
		border-left: 0;
		border-top: 0;
	}

	.pop-title {
		text-align: center;
		font-weight: bold;
		font-size: 18px;
		color: #222222;
		margin-bottom: 30px;
	}

	.phone-login {
		width: 127px;
		height: 28px;
		margin: 12px auto;
		margin-left: 120px;
		cursor: pointer;
	}

	.phone-logins {
		width: 127px;
		height: 28px;
		margin-top: 25px;
		z-index: 99999999;
		cursor: pointer;
	}

	.inp-text {
		width: 360px;
		height: 56px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EFEFEF;
		display: flex;
		align-items: center;
	}

	.inp-text-icon {
		width: 24px;
		height: 24px;
		margin-left: 20px;
	}

	/deep/ .no-border .el-input__inner {
		border: none !important;
		box-shadow: none !important;
	}

	.code-btn {
		width: 100px;
		font-weight: normal;
		font-size: 14px;
		color: #3377FF;
	}

	.pop-btn {
		width: 360px;
		height: 46px;
	}

	.close-icon {
		position: absolute;
		right: 30px;
		top: 30px;
	}

	.tabs {
		width: 350px;
		margin: auto;
		margin-bottom: 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.tabs-item {
		width: 80px;
		text-align: center;
		padding: 6px 0;
		font-weight: normal;
		font-size: 14px;
		color: #666666;
	}

	.tabs-items {
		width: 80px;
		text-align: center;
		padding: 6px 0;
		font-weight: 600;
		font-size: 15px;
		color: #222222;
		border-bottom: 2px solid #222222;
	}

	/* .impowerBox .title { display: none;}.impowerBox .status.status_browser { display: none;}.impowerBox .qrcode { border: none; width: 120px; height: 120px;margin-top: 0;border: 1px solid #eeeeee;border-radius: 10px;}.impowerBox .status{ display: none} */
</style>